<script lang="ts">
    import { slide } from 'svelte/transition';
	import {link}    from 'svelte-spa-router'

	import InputTitle   from "./ToolFormInputTitle.svelte";
    import InputPresets from "./ToolFormInputPresets.svelte";
	import DownloadZip  from './ToolFormDownloadZip.svelte';

	let base_json   : string = '';
	let add_json    : string = '';
	let preset_name : string = '';

	let base_images : { name: string; data: string }[] = [];
	let add_images  : { name: string; data: string }[] = [];

	let zip_data : string = '';
	let zip_name : string = '';

	async function doPost() {
		const res = await fetch('https://vroid.knta.cc', {
			method: 'POST',
			body: JSON.stringify({
				base_json,
				base_images,
				add_json,
				add_images,
				preset_name
			})
		});

		const json = await res.json();
		zip_data = json.zip_file_data;
		zip_name = json.zip_file_name;
	}

	function reset() {
		base_json   = ''
		add_json    = ''
		preset_name = ''
		base_images = []
		add_images  = []
		zip_data    = ''
		zip_name    = ''
	}
</script>

<div>
	{#if !zip_data}
		<InputTitle bind:preset_name={preset_name} />
		{#if preset_name !== ''}
			<InputPresets bind:base_json={base_json} bind:base_images={base_images}
						  bind:add_json={add_json}   bind:add_images={add_images} />
		{/if}
		{#if add_images.length > 0}
			<div transition:slide>
				<h3>STEP 4. 準備完了</h3>
				<div>
					<input type="button" value="合成！" on:click={doPost}>
				</div>
			</div>
		{/if}
	{:else}
		<DownloadZip bind:zip_data={zip_data}  bind:zip_name={zip_name}/>
		<div transition:slide >
			<a href="/tool/" on:click={reset} use:link>もう一度！</a>
		</div>
	{/if}
</div>